"use strict";
/*
 * Copyright 2017 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDarkTheme = void 0;
var tslib_1 = require("tslib");
require("../configureDom4");
var Classes = tslib_1.__importStar(require("../classes"));
function isDarkTheme(element) {
    return element != null && element instanceof Element && element.closest(".".concat(Classes.DARK)) != null;
}
exports.isDarkTheme = isDarkTheme;
//# sourceMappingURL=isDarkTheme.js.map